// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInWithCustomToken } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAR-f7bPcc1LyYKsrAU1uWWOoPD-QcybB0",
  authDomain: "pfx-trader.firebaseapp.com",
  databaseURL: "https://pfx-trader-default-rtdb.firebaseio.com",
  projectId: "pfx-trader",
  storageBucket: "pfx-trader.firebasestorage.app",
  messagingSenderId: "920259645048",
  appId: "1:920259645048:web:71a93a7f4604d1162e678d",
  measurementId: "G-EH68GJNZPC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
export const auth = getAuth(app);
